<template>
  <div class="auth-page d-flex justify-content-center align-items-center">
    <mdb-container>
      <mdb-alert
        v-if="showAlert"
        class="d-flex justify-content-center"
        color="danger"
      >
        {{ alertText }}
      </mdb-alert>
      <mdb-card style="width: 100%;">
        <mdb-card-header color="dark">Sign in to virallyze</mdb-card-header>
        <mdb-card-body class="w-100">
          <form>
            <div class="grey-text">
              <mdb-input
                label="Your email"
                icon="envelope"
                type="email"
                v-model="email"
              />
              <mdb-input
                label="Your password"
                icon="lock"
                type="password"
                v-model="password"
              />
            </div>
            <div class="text-center">
              <mdb-btn color="indigo" :disabled="signInDisabled" @click="login"
                >Log In</mdb-btn
              >

              <p>
                Don't have an account yet?
                <a href="/register">Sign up now.</a>
              </p>
            </div>
          </form>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbBtn,
  mdbAlert,
} from "mdbvue";

export default {
  name: "Login",
  components: {
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbAlert,
  },
  data() {
    return {
      email: "",
      password: "",
      showAlert: false,
    };
  },
  computed: {
    signInDisabled: function() {
      return this.email === "" || this.password === "";
    },
  },
  methods: {
    login: function() {
      let email = this.email;
      let password = this.password;
      this.$store
        .dispatch("user/login", { email, password })
        .then(() => {
          const redirectUrl = this.$store.getters.loginRedirectUrl;
          this.$store.commit("set_login_redirect_url", "");

          if (redirectUrl === "") {
            this.$router.push("/dashboard");
          } else {
            this.$router.push(redirectUrl);
          }
        })
        .catch((err) => {
          if (err.response.data.status === 403) {
            this.showAlert = true;
            this.alertText = err.response.data.message;
          }
        });
    },
  },
};
</script>
